module.exports = "<!-- Footer -->\r\n<footer id=\"page-footer\" class=\"content-mini content-mini-full font-s12 bg-gray-lighter clearfix\">\r\n  <div class=\"pull-right\">\r\n    <!--Crafted with <i class=\"fa fa-heart text-city\"></i> by <a class=\"font-w600\" href=\"#\" target=\"_blank\">Taritas</a>-->\r\n  </div>\r\n  <div class=\"pull-left\">\r\n    <a class=\"font-w600\" href=\"#\" target=\"_blank\">TGS 0.1</a> &copy; <span class=\"js-year-copy\">2018</span>\r\n  </div>\r\n</footer>\r\n<!-- END Footer -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = ./src/app/components/footer/footer.component.html
// module chunks = main